<template>
  <div id="app">
    <v-app>
      <template v-if="displayNavs">
        <LeftNav :open="leftNav"></LeftNav>
        <TopNav @right-nav-toggle="rightNav = !rightNav"></TopNav>
        <RightNav :open="rightNav"></RightNav>
      </template>
      <v-content class>
        <v-fade-transition mode="out-in">
          <router-view />
        </v-fade-transition>
      </v-content>
      <spinner class="spinner"></spinner>
      <Snackbar></Snackbar>
      <v-dialog
        v-if="$root.resourcePicker.status"
        v-model="$root.resourcePicker.status"
        scrollable
        fullscreen
        persistent
        transition="dialog-transition"
      >
        <ResourcePicker
          @resources-selected="resourceSelected($event)"
          @closeModal="$root.resourcePicker.status = false"
          :auth-token="vg_user.token"
          :api-token="resourcesApiToken"
          :allow-multiple="true"
        />
      </v-dialog>
      <DeleteModal
        :title="$root.deleteModal.title"
        :status="$root.deleteModal.status"
        :callback="$root.deleteModal.callback"
        :description="$root.deleteModal.description"
        @success="deleteModalSuccess"
        @close="closeDeleteModal"
      />
      <v-offline @detected-condition="handleConnectivityChange"></v-offline>
    </v-app>
  </div>
</template>
<script>
import { EventBus } from '@/event-bus'
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {
    TopNav: () => import('@/components/layout/TopNav'),
    VOffline: () => import('v-offline'),
    LeftNav: () => import('@/components/layout/LeftNav'),
    RightNav: () => import('@/components/layout/RightNav'),
    Spinner: () => import('@/components/custom-components/BlockSpinner'),
    Snackbar: () => import('@/components/custom-components/snackbar/snackbar.vue'),
    ResourcePicker: () => import('@/plugins/unoapp-resource-picker/app.resource.picker'),
    DeleteModal: () => import('./components/custom-components/DeleteModal.vue')
  },
  data() {
    return {
      leftNav: true,
      rightNav: false
    }
  },
  created() {
  console.log("triggering build");
    EventBus.$on('unauthorized', () => {
      this.va_clearAuthState()
      this.$router.push({ name: 'Login' })
    })
    EventBus.$on('show-error-modal', (error) => {
      if (error.response.status === 409) {
        this.swal({
          title: 'Error',
          text: error.response.data.msg,
          type: 'error',
          onAfterClose: this.$router.push(`/profile/${this.$route.params['id']}/store-info`)
        })
      } else {
        this.swal({
          title: 'Error',
          text: error.response.data.msg,
          type: 'error'
        })
      }
      this.spinner(false)
    })
  },
  methods: {
    ...mapActions({
      va_clearAuthState: 'auth/clearState',
      va_addLocationImage: 'locations/addLocationImage',
      va_getLocationImages: 'locations/getLocationImages'
    }),
    async resourceSelected(resource) {
      this.$root.resourcePicker.resource = resource
      this.$root.$emit('resource-selected', resource)
      console.log(resource)
      try {
        const data = {
          'location_id': this.vg_selectedLocation.id,
          'image_url': resource[0].full_url,
          'is_default': false,
          'sort_order': 2
        }
        let response = await this.va_addLocationImage({ data })
        this.va_getLocationImages({ locationId: this.vg_selectedLocation.id })
        this.swal({
          type: 'success',
          text: response.data.msg
        })
        console.log(response)
      } catch (error) {
        console.log(error)
        console.log(error.response)
      }
      this.$root.resourcePicker.status = false
    },
    closeDeleteModal() {
      this.$root.deleteModal = {
        status: false,
        title: '',
        description: '',
        callback: null,
        eventEmitOnSuccess: ''
      }
    },
    deleteModalSuccess(s) {
      this.$root.$emit(this.$root.deleteModal.eventEmitOnSuccess, s)
      this.closeDeleteModal()
    },
    handleConnectivityChange(connectivity) {
      console.log(connectivity)
      if (!connectivity) {
        this.swal({ type: 'error', title: 'Connection Lost', text: 'The app needs an active internet connection to work. Please check your internet and try again.' })
      }
    }
  },
  computed: {
    ...mapGetters({
      vg_user: 'auth/user',
      vg_selectedLocation: 'locations/selectedLocation'
    }),
    isLoggedIn() {
      let user = this.vg_user
      if (!user || user === undefined || user === '') {
        return false
      }
      return true
    },
    displayNavs() {
      // we dont need any navs on response catch for clover
      if(this.$route.name == 'CloverResponse') {
        return false;
      }
      return this.isLoggedIn && !this.isLoginRoute
    },
    isLoginRoute() {
      return this.$route.name === 'Login'
    },
    resourcesApiToken() {
      return process.env.VUE_APP_UNOAPP_RESOURCES_API_TOKEN
    }
  }
}
</script>
<style>
.google-autocomplete {
  display: block;
  border-bottom: solid thin #ccc;

  width: 100%;
  padding-bottom: 5px;
  outline: none;
}
.google-autocomplete:hover,
.google-autocomplete:focus {
  border-bottom: solid thin red;
}
.spinner {
  z-index: 9999 !important;
}
</style>
